<template>
  <article class="layout-section">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Week Schedule Component</h2>
      <p>
        <span class="type-code">ScheduleWeek.vue</span>
        &
        <span class="type-code">_schedule-week.scss</span>
      </p>
    </div>

    <ScheduleWeek />
  </article>
</template>

<script>
export default {
  name: 'DemoSchedule'
}
</script>
